import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {Subscription} from "rxjs";

import {Saseung, SaseungHanja} from "../../models/saseung.model";
import {getContentSize, GetHanjaHtml, SetHunHightlight} from "../../defines/client.func";
import {GetSaseungTxt} from "../../defines/gukeo.func";
import {clickOutsideLinkMixin} from "../../mixin/click-outside.mixin";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {SASEUNG_HANJAS, SaseungHanjaService} from "../../services/saseung-hanja/saseung-hanja.service";


const MAX_HUN_ITEM = 3;


@Component({
  selector: 'app-hun-popup',
  templateUrl: './hun-popup.component.html',
  styleUrls: ['./hun-popup.component.scss']
})
export class HunPopupComponent extends clickOutsideLinkMixin implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('style.position') stylePosition = 'absolute';
  @HostBinding('style.top') styleTop = "0";
  @HostBinding('style.left') styleLeft = "0";
  @Input() hun?: string;
  @Output() close = new EventEmitter<string | null>();
  @Output() viewInit = new EventEmitter<HTMLElement>();

  protected readonly GetSaseungTxt = GetSaseungTxt;
  protected readonly GetHanjaHtml = GetHanjaHtml;

  private load$: Subscription | null = null;
  listSaseungHanja: Array<SaseungHanja> | null = null
  private totalSaseungCount = 0;

  protected get IsLoading(): boolean {
    return this.load$ !== null;
  }

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    private saseungHanjaSvc: SaseungHanjaService,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit() {
    // 상위 position: relative (또는 static이 아닌) 인 요소 찾기
    const offsetParent = this.elementRef.nativeElement.offsetParent as HTMLElement;
    if (!offsetParent) {
      throw new Error('LinkPopupComponent.ngOnInit: offsetParent is null');
    }

    const {height} = getContentSize(offsetParent);
    this.styleTop = `${height + 5}px`;

    // mixin을 이용해서 팝업창 외부를 클릭했는지 체크한다.
    this.coInit(() => this.close.emit(null));

    if (this.hun) {
      this.load$ = this.saseungHanjaSvc.GetHuns(this.hun).subscribe(
        (shInfo: SASEUNG_HANJAS) => {
          console.warn('HunPopupComponent.ngOnInit: head', shInfo);

          this.totalSaseungCount = shInfo.totalCount;
          this.listSaseungHanja = shInfo.saseungHanjas.slice(0, MAX_HUN_ITEM);
        },
        (error) => {
          console.error('HunPopupComponent.ngOnInit: error', error);
        },
        () => {
          this.load$ = null;
        }
      );
    }
  }

  ngAfterViewInit() {
    this.viewInit.emit(this.elementRef.nativeElement.firstChild);
  }

  ngOnDestroy() {
    this.coDestroy();
  }

  protected getMoreTxt(): string | null {
    let moreTxt: string | null = null;
    const hunCount = this.totalSaseungCount - (this.listSaseungHanja?.length ?? 0);
    moreTxt = hunCount ? `${hunCount}개의 훈이 더 있습니다.` : null;
    return moreTxt;
  }

  /**
   * 상위 요소로 이벤트 전파를 막는다.
   * @param event
   */
  onVoid(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);
  }

  onCloseMore($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.hun);
  }

  onClose($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }

  protected GetMeaning(saseung: Saseung) {
    return SetHunHightlight(saseung.meaning, this.hun!) + ` <b>${saseung.hangul}</b>`;
  }
}
